/**
 * FO-324 P3 — gedeelde term-constanten voor het doel-type van een toeslag-regel.
 *
 * Elke plek die een toeslag toont (verloningsperiode, reservering, tarieven,
 * werkbon-facturatie, instellingen, exports) gebruikt deze labels, zodat overal
 * ondubbelzinnig staat welke wereld het betreft: "toeslag verloning" (CAO,
 * medewerker) vs "toeslag facturatie" (klanttarief).
 */

/** Doel-type van een toeslag-regel (== `ToeslagKind` in @streep/utils / Prisma). */
export type ToeslagDoelType = 'VERLONING' | 'FACTURATIE'

/** Volledig label per doel-type (koppen, kaarten). */
export const TOESLAG_DOELTYPE_LABELS: Record<ToeslagDoelType, string> = {
  VERLONING: 'Toeslag verloning',
  FACTURATIE: 'Toeslag facturatie',
}

/** Uitgebreid label met de wereld erbij (secties, tooltips). */
export const TOESLAG_DOELTYPE_LABELS_LANG: Record<ToeslagDoelType, string> = {
  VERLONING: 'Toeslag verloning (CAO)',
  FACTURATIE: 'Toeslag facturatie (klanttarieven)',
}

/** Korte badge-tekst per doel-type. */
export const TOESLAG_DOELTYPE_BADGE: Record<ToeslagDoelType, string> = {
  VERLONING: 'Verloning',
  FACTURATIE: 'Facturatie',
}
